import AuthRoutes from "@/views/auth/routes/index.js";
import SocialRouter from "@/views/social/routes/index.js";
import AdminRouter from "@/views/admin/routes/Index.js";
import VolunteerViewRouter from "@/views/volunteer-view/routes/Index.js";
import CMSRouter from "@/views/cms/routes/index.js";
import ChannelRoutes from "@/views/channel/routes/index.js";
// import jwt from "jsonwebtoken";
import swal from "sweetalert2";
import VendorRoutes from "@/views/vendor/routes/index.js";
import auth from "@/store";
const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/home",
    component: () => import("../views/MainPage.vue"),
    children: [
      ...SocialRouter,
      ...AdminRouter,
      ...ChannelRoutes,
      ...VolunteerViewRouter,
      ...VendorRoutes,
      {
        path: "home",
        name: "home",
        component: () => import("../views/home/HomePage.vue"),
      },
      {
        path: "pagenotfound",
        name: "pagenotfound",
        component: () => import("../views/pagenotfound/Pagenotfound.vue"),
      },
      {
        path: "Final-landing",
        name: "Final-landing",
        component: () => import("../views/Final-landing/Final-Landing.vue"),
      },
      {
        path: "playlists",
        name: "playlists",
        component: () => import("../views/playlists/Playlists.vue"),
      },
      {
        path: "channelpage",
        name: "channelpage",
        component: () => import("../views/channelpage/Channelpage.vue"),
      },
      {
        path: "videospage",
        name: "videospage",
        component: () => import("../views/playlistpage/Playlistpage.vue"),
      },
      // {
      //   path: "pdfviewer",
      //   name: "pdfviewer",
      //   component: () =>
      //     import("../views/insights/tools/components/PDFviewer.vue"),
      // },
      {
        path: "caregiver",
        name: "caregiver",
        component: () => import("../views/caregiver/Caregiver.vue"),
      },
      {
        path: "service-form",
        name: "serviceform",
        component: () => import("../views/product/components/ServiceForm.vue"),
      },

      {
        path: "ecommerce",
        name: "ecommerce",
        component: () => import("../views/ecommerce/Ecommerce.vue"),
      },
      {
        path: "product-services",
        name: "product-services",
        component: () => import("../views/product/Product.vue"),
      },
      {
        path: "subscribe1",
        name: "subscribe1",
        component: () => import("@/views/subscribe/components/Cards1.vue"),
      },
      {
        path: "wellwisher",
        name: "wellwisher",
        component: () => import("../views/wellwisher/Wellwisher.vue"),
      },
      {
        path: "hcp",
        name: "hcp",
        component: () => import("../views/hcp/HCP.vue"),
      },
      {
        path: "volunteer-register",
        name: "volunteer-register",
        component: () => import("../views/hcp/components/HcpRegister.vue"),
      },
      {
        path: "donation",
        name: "donation",
        component: () => import("../views/donation/Donation.vue"),
      },

      // Old route
      // {
      //   path: "corporate",
      //   name: "corporate",
      //   component: () => import("../views/corporate/Corporate.vue"),
      // },

      // New route
      {
        path: "corporate1",
        name: "corporate1",
        component: () => import("../views/corporate/Corporate.vue"),
      },

      {
        path: "about-us",
        name: "about-us",
        component: () => import("../views/about-us/AboutUs.vue"),
      },
      {
        path: "FOCGS",
        name: "friends-caregiversaathi",
        component: () =>
          import(
            "../views/friends-caregiversaathi/friends-caregiversaathi.vue"
          ),
      },
      {
        path: "regulation-policies-papers",
        name: "regulation-policies-papers",
        component: () => import("../views/regulation-docs/regulation-docs.vue"),
      },
      {
        path: "coach",
        name: "coach",
        component: () => import("../views/coach/Coach.vue"),
      },
      {
        path: "privacy-policy",
        name: "privacy",
        component: () => import("../views/privacypolicy/PrivacyPolicy.vue"),
      },
      {
        path: "terms-condition",
        name: "terms",
        component: () => import("../views/terms/Terms.vue"),
      },

      {
        path: "community",
        name: "community",
        component: () => import("../views/community/Community.vue"),
      },
      {
        path: "heartofcare",
        name: "heartofcare",
        component: () => import("../views/heartofcare/HeartHome.vue"),
      },
      {
        path: "heartofcare/about",
        name: "about",
        component: () =>
          import("../views/heartofcare/heartabout/HeartAbout.vue"),
      },
      {
        path: "heartofcare/sharework",
        name: "sharework",
        component: () => import("../views/heartofcare/sharework/ShareWork.vue"),
      },

      {
        path: "heartofcare/connect",
        name: "connect",
        component: () => import("../views/heartofcare/connect/Connects.vue"),
      },

      {
        path: "heartofcare/gallery",
        name: "heartofcareGallery",
        component: () =>
          import("../views/heartofcare/heartGallery/Gallery.vue"),
      },
      {
        path: "heartofcare/master-class",
        name: "master-class",
        component: () =>
          import("../views/heartofcare/masterClass/MasterClass.vue"),
      },
      {
        path: "Care Directory",
        name: "Care Directory",
        component: () => window.open("http://20.244.105.20:8080/", "_blank"),
      },
      {
        path: "heartofcare/Dance",
        name: "Dance",
        component: () => import("../views/heartofcare/dance/Dance.vue"),
      },
      {
        path: "heartofcare/Creative",
        name: "Creative",
        component: () =>
          import("../views/heartofcare/creativejournal/Creative.vue"),
      },
      {
        path: "heartofcare/Poetry",
        name: "Poetry",
        component: () => import("../views/heartofcare/poetry/Poetry.vue"),
      },

      // {
      //   path: "insights",
      //   name: "insights",
      //   component: () => import("../views/insights/Insights.vue")
      // },
      {
        path: "insights/news",
        name: "news",
        component: () => import("../views/insights/news/News.vue"),
      },
      {
        path: "insights/news/pop-up",
        name: "newspopup",
        component: () => import("../views/insights/news/NewsPopup.vue"),
      },
      {
        path: "insights/blogs",
        name: "insights-blogs",
        component: () => import("../views/insights/blogs/Blogs.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem("token")) {
        //     next();
        //   } else {
        //     next({ name: "signin" });
        //   }
        // },
      },
      {
        path: "insights/blogsPage/:slug",
        name: "blogspage",
        component: () => import("../views/insights/blogs/BlogsPage.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem("token")) {
        //     next();
        //   } else {
        //     next({ name: "signin" });
        //   }
        // },
      },
      {
        path: "insights/events",
        name: "events",
        component: () => import("../views/insights/events/Events.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem("token")) {
        //     next();
        //   } else {
        //     next({ name: "signin" });
        //   }
        // },
      },
      {
        path: "insights/events/calendar",
        name: "events-calendar",
        component: () => import("../views/insights/events/EventsCalendar.vue"),
      },
      // {
      //   path: "/profile",
      //   name: "profile",
      //   component: () => import("../views/userProfile/Userprofile1.vue"),
      // },
      {
        path: "/profile",
        name: "profile",
        component: () => import("../views/profile/Profile.vue"),
      },

      {
        path: "insights/events/calendar2",
        name: "events-calendar2",
        component: () => import("../views/insights/events/EventsCalendar2.vue"),
      },
      {
        path: "insights/podcast",
        name: "podcast",
        component: () => import("../views/insights/podcast/Podcast.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem("token")) {
        //     next();
        //   } else {
        //     next({ name: "signin" });
        //   }
        // },
      },
      {
        path: "insights/toolsandhandbook",
        name: "toolsandhandbook",
        component: () => import("../views/insights/tools/ToolsHandbook.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem("token")) {
        //     next();
        //   } else {
        //     next({ name: "signin" });
        //   }
        // },
      },
      {
        path: "insights/ToolsPage/:slug",
        name: "ToolsPage",
        component: () => import("../views/insights/tools/ToolsPage.vue"),
        // beforeEnter: (to, from, next) => {
        //   if (localStorage.getItem("token")) {
        //     next();
        //   } else {
        //     next({ name: "signin" });
        //   }
        // },
      },

      {
        path: "insights/presentation",
        name: "presentation",
        component: () =>
          import("../views/insights/presentation/Presentation.vue"),
      },
      {
        path: "insights/presentation/presentation-page",
        name: "presentation-page",
        component: () =>
          import("../views/insights/presentation/PresentationPage.vue"),
      },
      {
        path: "join-us",
        name: "join-us",
        component: () => import("../views/join-us/JoinUs.vue"),
      },
      {
        path: "contact-us",
        name: "contact-us",
        component: () => import("../views/contact-us/ContactUs.vue"),
      },
      {
        path: "careers",
        name: "careers",
        component: () => import("../views/careers/Careers.vue"),
      },
      {
        path: "coach",
        name: "coach",
        component: () => import("../views/coach/Coach.vue"),
      },
      {
        path: "career-details",
        name: "career-details",
        component: () => import("../views/careers/CareerDetails.vue"),
      },
      {
        path: "jobdetails/:name/:id",
        name: "psychology-intern",
        component: () =>
          import("../views/careers/careerDetailsPage/CareerDetailsPsy.vue"),
      },
      {
        path: "social-media-intern",
        name: "social-media-intern",
        component: () =>
          import("../views/careers/careerDetailsPage/CareerDetailsSM.vue"),
      },
      {
        path: "it-and-operations-admin-intern",
        name: "it-and-operations-admin-intern",
        component: () =>
          import("../views/careers/careerDetailsPage/CareerDetailsIT.vue"),
      },
      // {
      //   path: "donate",
      //   name: "donate",
      //   component: () => import("../views/donate/Donate.vue"),
      // },
      {
        path: "register",
        name: "register",
        component: () => import("../views/register/Register.vue"),
      },

      {
        path: "sign-in",
        name: "signin",
        component: () => import("../views/signin/SignIn.vue"),
        beforeEnter: (to, from, next) => {
          const isAuthenticated = !!localStorage.getItem("userToken");

          if (isAuthenticated) {
            if (from.name === "home" || to.name === "home") {
              next(true);
            } else {
              next({ name: "home" });
            }
          } else {
            if (
              from.name &&
              from.name !== "login" &&
              from.name !== "register"
            ) {
              localStorage.setItem("lastPageBeforeLogin", from.fullPath);
            }
            next();
          }
        },
      },
      {
        path: "volunteer-sign-in",
        name: "volunteersignin",
        component: () => import("../views/signin/SignInVolunteer.vue"),
        // beforeEnter: (to, from, next) => {
        //   const isAuthenticated = !!localStorage.getItem("userToken");

        //   if (isAuthenticated) {
        //     if (from.name === "home" || to.name === "home") {
        //       next(false);
        //     } else {
        //       next({ name: "home" });
        //     }
        //   } else {
        //     if (
        //       from.name &&
        //       from.name !== "login" &&
        //       from.name !== "register"
        //     ) {
        //       localStorage.setItem("lastPageBeforeLogin", from.fullPath);
        //     }
        //     next();
        //   }
        // },
      },
      ,
      //Social Channel
      {
        path: "channel",
        name: "social-channel",
        component: () => import("../views/channel/Channel.vue"),
      },

      //Respite care
      {
        path: "care-assistance",
        name: "care-assistance",
        component: () => import("../views/respite-care/Respite-care.vue"),
        beforeEnter: (to, from, next) => {
          let user = { role: auth.getters["auth/userRole"] };
          if (["employee", "admin", "student"].includes(user.role)) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },

      //User-profile
      {
        path: "user-profile",
        name: "user-profile",
        component: () => import("../views/user-profile/User.vue"),
        beforeEnter: (to, from, next) => {
          let user = { role: auth.getters["auth/userRole"] };
          if (
            ["employee", "admin", "student", "volunteer"].includes(user.role)
          ) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },
      //sheduling page
      {
        path: "schedule",
        name: "schedule",
        component: () => import("../views/schedule/Session.vue"),
      },
      {
        path: "schedule-page",
        name: "schedule-page",
        component: () => import("../views/schedule/Session.vue"),
        beforeEnter: (to, from, next) => {
          let user = { role: auth.getters["auth/userRole"] };
          if (
            ["employee", "admin", "student", "volunteer"].includes(user.role)
          ) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },

      {
        path: "view-cart",
        name: "view-cart",
        component: () => import("../views/view-cart/ViewCart.vue"),
      },

      //Booking-page
      {
        path: "booking-page",
        name: "booking-page",
        component: () => import("../views/booking-page/Booking.vue"),
      },

      {
        path: "transaction",
        name: "transaction",
        component: () =>
          import("../views/booking-page/components/MyTransactions.vue"),
      },

      //Map-inside
      {
        path: "map-inside",
        name: "map-inside",
        props: true,
        component: () => import("../views/map-inside/Map-inside.vue"),
        beforeEnter: (to, from, next) => {
          let user = { role: auth.getters["auth/userRole"] };
          if (["employee", "admin", "student"].includes(user.role)) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },
      {
        path: "cg-coaching",
        name: "cg-coaching",
        props: true,
        component: () => import("../views/cg-coaching/Map-inside.vue"),
        // beforeEnter: (to, from, next) => {
        //   let user = { role: auth.getters["auth/userRole"] };
        //   if (["employee", "admin", "student"].includes(user.role)) {
        //     next();
        //   } else {
        //     next({ name: "home" });
        //   }
        // },
      },

      //care-assistance
      {
        path: "care-assistances",
        name: "care-assistances",
        props: true,
        component: () => import("../views/care-assistances/CareAssistance.vue"),
        // beforeEnter: (to, from, next) => {
        //   let user = { role: auth.getters["auth/userRole"] };
        //   if (["employee", "admin", "student"].includes(user.role)) {
        //     next();
        //   } else {
        //     next({ name: "home" });
        //   }
        // },
      },

      //therapy-counselling
      {
        path: "therapy-counselling",
        name: "therapy-counselling",
        props: true,
        component: () =>
          import("../views/therapy-counselling/TherapyCounselling.vue"),
        // beforeEnter: (to, from, next) => {
        //   let user = { role: auth.getters["auth/userRole"] };
        //   if (["employee", "admin", "student"].includes(user.role)) {
        //     next();
        //   } else {
        //     next({ name: "home" });
        //   }
        // },
      },

      //therapy-counselling
      {
        path: "inheritance",
        name: "inheritance",
        props: true,
        component: () => import("../views/inheritance/Inheritance.vue"),
        // beforeEnter: (to, from, next) => {
        //   let user = { role: auth.getters["auth/userRole"] };
        //   if (["employee", "admin", "student"].includes(user.role)) {
        //     next();
        //   } else {
        //     next({ name: "home" });
        //   }
        // },
      },

      // family-counselling
      {
        path: "family-counselling",
        name: "family-counselling",
        props: true,
        component: () =>
          import("../views/family-counselling/FamilyCounselling.vue"),
        // beforeEnter: (to, from, next) => {
        //   let user = { role: auth.getters["auth/userRole"] };
        //   if (["employee", "admin", "student"].includes(user.role)) {
        //     next();
        //   } else {
        //     next({ name: "home" });
        //   }
        // },
      },
      {
        path: "service-overview",
        name: "service-overview",
        props: true,
        component: () =>
          import("../views/service-overview/ServiceOverview.vue"),
        // beforeEnter: (to, from, next) => {
        //   let user = { role: auth.getters["auth/userRole"] };
        //   if (["employee", "admin", "student"].includes(user.role)) {
        //     next();
        //   } else {
        //     next({ name: "home" });
        //   }
        // },
      },

      //care-professionals
      {
        path: "request-form/:pathName",
        name: "request-form",
        props: true,
        component: () => import("../views/request-form/CareProfessionals.vue"),
      },
      {
        path: "request-form",
        name: "request-form",
        props: true,
        component: () => import("../views/request-form/CareProfessionals.vue"),
      },

      //volunteer-view
      {
        path: "volunteer-view",
        name: "volunteer-view",
        component: () =>
          import("../views/volunteer-view/layouts/Volunteer.vue"),
        beforeEnter: (to, from, next) => {
          let user = { role: auth.getters["auth/userRole"] };
          if (["volunteer"].includes(user.role)) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },

      //services
      {
        path: "services",
        name: "services",
        component: () => import("../views/services/Services.vue"),
        beforeEnter: (to, from, next) => {
          let user = { role: auth.getters["auth/userRole"] };
          if (["employee", "admin"].includes(user.role)) {
            next();
          } else {
            next({ name: "home" });
          }
        },
      },

      // E-learning
      {
        path: "e-learning/home",
        name: "e-home",
        component: () => import("../views/e-learning/home/Home.vue"),
      },
      {
        path: "e-learning/all-categories",
        name: "e-all-categories",
        component: () =>
          import("../views/e-learning/all-categories/AllCategories.vue"),
      },
      {
        path: "e-learning/all-courses",
        name: "e-courses",
        component: () => import("../views/e-learning/product/All-Courses.vue"),
      },
      {
        path: "e-learning/course-detail",
        name: "e-course-detail",
        component: () =>
          import("@/views/e-learning/product/coursedetail/CourseDetail.vue"),
      },
      {
        path: "e-learning/my-learning",
        name: "e-my-learning",
        component: () =>
          import("@/views/e-learning/my-learning/MyLearning.vue"),
        beforeEnter: (to, from, next) => {
          // if (localStorage.getItem("token")) {
          if (sessionStorage.getItem("token")) {
            next();
          } else {
            next({ name: "signin" });
            swal.fire({
              title: "",
              text: "Please login to access this content",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        },
      },
      {
        path: "/my-learning/certificate",
        name: "e-my-learning-certificate",
        component: () =>
          import("@/views/e-learning/certificate/Certificate.vue"),
      },
      {
        path: "/my-learning/e-certificate",
        name: "e-my-learning-e-certificate",
        component: () =>
          import("@/views/e-learning/my-learning/components/Certificate.vue"),
      },
      {
        path: "e-learning/cart",
        name: "e-cart",
        component: () => import("@/views/e-learning/cart/Cart.vue"),
        beforeEnter: (to, from, next) => {
          // if (localStorage.getItem("token")) {
          if (sessionStorage.getItem("token")) {
            next();
          } else {
            next({ name: "signin" });
            swal.fire({
              title: "",
              text: "Please login to access this content",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        },
      },
      {
        path: "e-learning/profile",
        name: "e-profile",
        component: () => import("@/views/e-learning/profile/Profile.vue"),
      },
      {
        path: "e-learning/product-all",
        name: "product-all",
        component: () => import("@/views/e-learning/product/All-Courses.vue"),
      },
      {
        path: "e-learning/wishlist",
        name: "e-wishlist",
        component: () =>
          import("@/views/e-learning/product/wishlist/Wishlist.vue"),
        beforeEnter: (to, from, next) => {
          // if (localStorage.getItem("token")) {
          if (sessionStorage.getItem("token")) {
            next();
          } else {
            next({ name: "signin" });
            swal.fire({
              title: "",
              text: "Please login to access this content",
              icon: "warning",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }
        },
      },
      {
        path: "e-learning/course",
        name: "course",
        component: () => import("@/views/e-learning/course/Course.vue"),
      },
      {
        path: "e-learning/learningCourse",
        name: "learningCourses",
        component: () =>
          import("@/views/e-learning/learningCourses/Course.vue"),
      },
      {
        path: "subscribe",
        name: "subscribe",
        component: () => import("@/views/subscribe/Subscribe.vue"),
      },

      {
        path: "planoverview",
        name: "planoverview",
        component: () =>
          import("@/views/subscribe/components/PlanOverview.vue"),
      },
      {
        path: "cancel-subscription",
        name: "cancelsubscription",
        component: () =>
          import("@/views/profile/components/tabs/CancelSubscription.vue"),
      },

      // Old Route
      // {
      //   path: "Final-landing",
      //   name: "Final-landing",
      //   component: () => import("../views/Final-landing/Final-Landing.vue"),
      // },

      // New route
      {
        path: "corporate",
        name: "corporate",
        component: () => import("../views/Final-landing/Final-Landing.vue"),
      },
      {
        path: "corporate/corporate-events",
        name: "corporate-events",
        component: () =>
          // import("../views/corporate-events/CorporateEvents.vue"),
          import("../views/insights/events/Events.vue"),
      },
      {
        path: "futures",
        name: "futures",
        component: () => import("../views/future-trends/FutureTrends.vue"),
      },
      {
        path: "wellbeing-initiatives",
        name: "wellbeing-initiatives",
        component: () =>
          import("../views/wellbeing-initiatives/WellbeingInitiatives.vue"),
      },
      {
        path: "event-singlepage",
        name: "event-singlepage",
        component: () => import("../views/singleevents/SingleEvents.vue"),
      },
      {
        path: "Corporate/ffc-podcast",
        name: "ffc-podcast",
        // component: () => import("../views/ffc-podcast/FfcPodcast.vue"),
        component: () => import("../views/insights/podcast/Podcast.vue"),
      },
      {
        path: "campaign/:id",
        name: "campaign-user",
        component: () => import("../views/campaign/Campaign.vue"),
      },
      {
        path: "aboutcampaign",
        name: "aboutcampaign-user",
        component: () => import("../views/aboutcampaign/AboutCampaign.vue"),
      },
      {
        path: "insights/gallery",
        name: "insights-gallery",
        component: () => import("../views/insights/gallery/Gallery.vue"),
      },
      {
        path: "gallery-singlepage/:id",
        name: "gallery-singlepage",
        component: () =>
          import("../views/insights/gallery/components/SingleGallery.vue"),
      },
      {
        path: "medical_cancer",
        name: "medical_cancer",
        component: () => import("../views/medical/Medical.vue"),
      },
      {
        path: "medical_neurologicaldisorders",
        name: "medical_neurologicaldisorders",
        component: () => import("../views/medical/Neurology.vue"),
      },
      {
        path: "neurological_disorder",
        name: "neurological_disorder",
        component: () => import("../views/medical/Disorder.vue"),
      },
      {
        path: "medical_faq",
        name: "medical_faq",
        component: () => import("../views/medical/Medical.vue"),
      },
      {
        path: "medical_palliative",
        name: "medical_palliative",
        component: () => import("../views/medical/AboutTabs.vue"),
      },
      {
        path: "medical_dementia",
        name: "medical_dementia",
        component: () => import("../views/medical/Dementia.vue"),
      },
      {
        path: "podcast-seasonpage",
        name: "podcast-seasonpage",
        component: () => import("../views/seasonpage/Seasonpage.vue"),
      },
      {
        path: "podcast-episodepage",
        name: "podcast-episodepage",
        component: () => import("../views/insights/podcast/PodcastPage.vue"),
      },
    ],
  },
  {
    path: "/selfhelptools-pdf",
    name: "pdfviewer",
    component: () => import("@/views/insights/tools/components/PDFviewer.vue"),
  },
  {
    path: "*",
    redirect: "pagenotfound",
  },
  ...AuthRoutes,
  ...CMSRouter,
];

export default routes;
